import PricebookGrid from "./PricebookGrid";

export default PricebookGrid;



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricebookGrid/index.js